import { BrandListSpace } from 'src/types/api'
import Accordion from 'src/components/common/Accordion'
import { Noto_body2_b14, Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'
import { Container } from 'src/components/common/Container'
import React from 'react'
import styled, { css } from 'styled-components'
import { CouponMapProps } from 'src/pages/CouponMapPage'

import {
  Chips,
  ChipsDefaultStyle,
  ChipsItemsMiddleStyle,
  ChipsItemStyle,
  ChipsListStyle,
} from 'src/components/common/Chips'
import RenderIf from 'src/components/common/RenderIf'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { layoutMaxSize } from 'src/styles/mixin'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { Icon } from 'src/assets/svg/Icon'

const BrandMenuBottomSheetBody = ({
  brandList,
  handleSearchBrandListSetting,
  handleSearchStoresByBrandList,
  searchBrandList,
  ownedCouponList,
  popularBrandList,
  userInterestBrandList,
  handleUpdateUserInterestBrandList,
}: CouponMapProps) => {
  const recommendChipsLists = [
    { title: '보유 쿠폰 브랜드', brandLists: ownedCouponList },
    { title: '최근에 본 브랜드', brandLists: userInterestBrandList },
    { title: '최근 인기 브랜드', brandLists: popularBrandList },
  ]

  return (
    <S.BrandMenuBodyContainer $option="flex_column" $row_gap="10px">
      {/*추천 브랜드: 최근에 본 브랜드, 최근 인기 브랜드 등*/}
      <S.BrandMenuRecommend.Container $option="flex_column">
        {recommendChipsLists.map(({ title, brandLists }) => (
          <RenderIf when={brandLists?.length !== 0} key={title}>
            <S.BrandMenuRecommend.Items $option="flex_column" $row_gap="12px">
              <S.BrandMenuRecommend.Title $title={title} />
              <CustomSwiper.Wrap type="default" gap={6} $wrapstyle={S.SwiperChipsListStyle}>
                {brandLists?.map((brand, i: number) => {
                  const chipsActive = searchBrandList!?.some((w) => w.brandName === brand.brandName)
                  const handleSetSearchBrandList = () => handleSearchBrandListSetting.set(brand)
                  const updateUserInterestBrandList = (e: MouseEvent) =>
                    handleUpdateUserInterestBrandList(e, brand.brandName)

                  return (
                    <CustomSwiper.Item
                      key={brand.brandNumber}
                      onClick={handleSetSearchBrandList}
                      $itemstyle={S.SwiperChipsItemsStyle(i === 0, chipsActive)}
                    >
                      {brand.brandName}
                      <RenderIf when={title === '최근에 본 브랜드'}>
                        <Icon.GrayCircleX size="16" onClickFn={updateUserInterestBrandList} />
                      </RenderIf>
                    </CustomSwiper.Item>
                  )
                })}
              </CustomSwiper.Wrap>
            </S.BrandMenuRecommend.Items>
          </RenderIf>
        ))}
      </S.BrandMenuRecommend.Container>
      {/*아코디언 브랜드*/}
      <S.BrandMenuAccordion.Container $option="flex_column">
        {brandList?.map(
          (
            { BrandList, CategoryNumber, CategoryName }: BrandListSpace.BrandInfoType,
            i: number,
          ) => (
            <Accordion
              key={i}
              type="middle"
              Title={CategoryName}
              TitleStyle={S.BrandMenuAccordion.TitleStyle}
              defaultStatus={i === 0}
            >
              <S.BrandMenuAccordion.Items $option="flex_row_wrap" $column_gap="6px">
                <Chips.List style={S.BrandMenuAccordion.ChipsListStyle}>
                  {BrandList?.map(({ BrandName, BrandNumber }: BrandListSpace.BrandListType) => {
                    const handleSetSearchBrandList = () =>
                      handleSearchBrandListSetting.set({
                        categoryNumber: CategoryNumber,
                        brandName: BrandName,
                        brandNumber: BrandNumber,
                      })
                    const chipsActive = searchBrandList!?.some((w) => w.brandName === BrandName)
                    return (
                      <RenderIf when={!BrandName?.includes('금액권')} key={BrandName}>
                        <Chips.Item
                          size="middle"
                          onClickFn={handleSetSearchBrandList}
                          style={S.BrandMenuAccordion.ChipsItemsStyle(chipsActive)}
                        >
                          {BrandName}
                        </Chips.Item>
                      </RenderIf>
                    )
                  })}
                </Chips.List>
              </S.BrandMenuAccordion.Items>
            </Accordion>
          ),
        )}
      </S.BrandMenuAccordion.Container>
      <S.BrandMenuFloat.Container $option="flex_column">
        <RenderIf when={searchBrandList?.length !== 0}>
          <S.BrandMenuFloat.SelectedBrandList $option="flex_row" $column_gap="10px">
            <Icon.Wastebasket onClickFn={handleSearchBrandListSetting.reset} />
            <CustomSwiper.Wrap type="default" gap={6} $wrapstyle={S.SwiperChipsListStyle}>
              {searchBrandList?.map((brand) => (
                <CustomSwiper.Item
                  key={brand.brandNumber}
                  onClick={() => handleSearchBrandListSetting.set(brand)}
                  $itemstyle={S.SwiperChipsItemsStyle(
                    false,
                    searchBrandList!?.some((w) => w.brandName === brand.brandName),
                  )}
                >
                  {brand.brandName}
                  <Icon.BlueX />
                </CustomSwiper.Item>
              ))}
            </CustomSwiper.Wrap>
          </S.BrandMenuFloat.SelectedBrandList>
        </RenderIf>
        <Button
          option={ButtonOption3('active')}
          onClickFn={handleSearchStoresByBrandList}
          style={S.BrandMenuFloat.SubmitButtonStyle}
          disabled={searchBrandList?.length === 0}
        >
          적용
        </Button>
      </S.BrandMenuFloat.Container>
    </S.BrandMenuBodyContainer>
  )
}
export default BrandMenuBottomSheetBody

const S = {
  BrandMenuBodyContainer: styled(Container)`
    overflow-y: scroll;
    padding-bottom: 116px;

    &::-webkit-scrollbar,
    &::-webkit-scrollbar-thumb {
      display: none;
    }
  `,
  SwiperChipsListStyle: css`
    ${ChipsListStyle()};
    padding: 1px 0;
  `,
  SwiperChipsItemsStyle: (firstIndex: boolean, active?: boolean) => css`
    ${ChipsItemStyle};
    ${ChipsItemsMiddleStyle};
    gap: 4px;
    ${firstIndex &&
    css`
      margin-left: 20px;
    `}
    ${active
      ? css`
          border: 1px solid var(--brand-40);
          background: var(--brand-5);
          color: var(--brand-50);
          ${Noto_body2_b14};
        `
      : ChipsDefaultStyle()};
  `,

  BrandMenuRecommend: {
    Container: styled(Container)``,
    Items: styled(Container)`
      padding: 22px 0 0 0;
      overflow-x: auto;
    `,
    Title: styled.p<{ $title: string }>`
      width: fit-content;
      margin-left: 20px;

      &:after {
        content: '${(props) => props.$title}';
        color: var(--black-70);
        ${Noto_body2_m14};
      }
    `,
  },
  BrandMenuAccordion: {
    Container: styled(Container)`
      border-bottom: 1px solid var(--black-6);
    `,
    Items: styled(Container)`
      padding: 0 20px 20px 20px;
    `,
    ChipsListStyle: css`
      overflow-x: unset;
      flex-wrap: wrap;
    `,
    ChipsItemsStyle: (active?: boolean) => css`
      ${active &&
      css`
        border: 1px solid var(--brand-40);
        background: var(--brand-5);
        color: var(--brand-50);
        ${Noto_body2_b14};
      `}
    `,
    TitleStyle: css`
      ${Noto_body2_m14};
      color: var(--black-70);
    `,
  },

  BrandMenuFloat: {
    Container: styled(Container)`
      position: fixed;
      z-index: 1;
      bottom: 0;
      background-color: var(--white);
      ${layoutMaxSize};
      border-top: 1px solid var(--black-4);
    `,
    SelectedBrandList: styled(Container)`
      position: relative;
      margin-left: 10px;
      align-items: center;
      padding: 16px 0 6px 0;
    `,
    SubmitButtonStyle: css`
      width: calc(100% - 20px);
      margin: 10px auto 10px auto;
    `,
  },
}
